import {
  Avatar,
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid2,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as GoogleIcon } from "Assets/Icons/Auth//GoogleIcon.svg";
import { ReactComponent as LinkedinIcon } from "Assets/Icons/Auth//LinkedinIcon.svg";
import { ReactComponent as GithubIcon } from "Assets/Icons/Auth//GithubIcon.svg";
import OTPInput from "Components/Common/OTPInput";
import { useFormik } from "formik";
import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { sendOTP } from "Services/service";
import { verifyOTP } from "Slices/thunks";
import {
  GoogleAuthProvider,
  OAuthProvider,
  GithubAuthProvider,
  linkWithPopup,
  unlink,
  signInWithRedirect,
  signInWithPopup
} from "firebase/auth";
import { auth } from "firebase.js";
import { toast } from "react-toastify";

const socialMedias = [
  {
    label: "Google",
    icon: GoogleIcon,
    providerId: 'google.com'
  },
  {
    label: "LinkedIn",
    icon: LinkedinIcon,
    providerId: 'linkedin.com'
  },
  {
    label: "Github",
    icon: GithubIcon,
    providerId: 'github.com'
  },
];

const ChangeEmailSection = ({ profileInfo }) => {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState('');
  const [tab, setTab] = useState(1);
  const [socialMediaProvider, setSocialMediaProvider] = useState([]);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  const Schema = useMemo(() => {
    return yup.object({
      UpdateEmail: yup.string().required(Translation?.EmailRequired || "Email is required field.")
    });
  }, [Translation]) 

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: profileInfo,
    enableReinitialize: true,
    onSubmit: async (data) => {
      try {
        await sendOTP({IsEmail: true, Email: data.UpdateEmail})
        setTab(2);
      } catch (error) {
        if (error.status === 404) {
          setErrors({UpdateEmail: Translation?.UserAlreadyExists});
        } else {
          toast.error(Translation?.SomethingWentWrong);
        }
      }
    },
    validationSchema: Schema,
  });



  const handleVerifyOtp = async () => {
    try {
      await dispatch(verifyOTP({IsEmail: true, Email: values.UpdateEmail, OTP: otp})).unwrap();
      setFieldValue('UpdateEmail', '')
      setOtp('');
      setTab(1)
      toast.success(Translation?.EmailUpdatedSuccessfully)
    } catch (error) {
      console.log('error: ', error);
      if (error.status === 400) {
        toast.error(Translation?.OTPMismatch)
      } else {
        toast.error(Translation?.SomethingWentWrong);
      }
    }
  }

  const handleLinkedAccount = async (socialMedia, providerId) => {
    let response = {};
    try {
      if (socialMedia === 'Google') {
        const provider = new GoogleAuthProvider();
        response = await linkWithPopup(auth.currentUser, provider);

      } else if (socialMedia === 'LinkedIn') {
        const provider = new OAuthProvider('oidc.linkedin');

        // provider.addScope('r_liteprofile');
        // provider.addScope('email');

        response = await linkWithPopup(auth.currentUser, provider)
        // response = await signInWithRedirect(auth, provider);
        // response = await signInWithPopup(auth, provider)
        console.log('response: ', response);
        
      } else if (socialMedia === 'Github') {
        const provider = new GithubAuthProvider();
        response = await linkWithPopup(auth.currentUser, provider);
        
      }

      if (socialMedia !== 'LinkedIn' && profileInfo.Email === response?._tokenResponse?.email) {
        setSocialMediaProvider([...socialMediaProvider, providerId])
        toast.success(`${Translation[socialMedia] || ""} ${Translation?.AccountLinked}`);
       
      } else {
        await unlink(auth.currentUser, providerId);
        toast.error(Translation?.EmailAddressMismatch);

      }
      
    } catch (error) {
      console.log('error: ', error);
      if (error.message.includes("auth/email-already-in-use")) {
        toast.error(Translation?.EmailAlreadyRegistered)
      } else {
        toast.error(Translation?.SomethingWentWrong);
      }
    }
  }

  const handleRemoveAccount = async (socialMedia, providerId) => {
    try {
      if (auth.currentUser) {
        await unlink(auth.currentUser, providerId);
        setSocialMediaProvider(socialMediaProvider?.filter((p) => p != providerId));
        toast.success(`${Translation[socialMedia] || ""} ${Translation?.AccountUnlinked}`);
      } 

    } catch (error) {
      console.log('error: ', error);
      toast.error(Translation?.SomethingWentWrong);
    }
  }

  useEffect(() => {
    if (auth.currentUser?.providerData) {
      const providers = (auth.currentUser?.providerData || []).map((p) => p.providerId)
      setSocialMediaProvider(providers)
    }

  }, [auth.currentUser])

  return (
    <Grid2 size={6} display={"flex"} flexDirection={"column"} gap="15px">
      <Typography fontWeight={500} variant="title">
        {Translation?.UpdateEmailDetails}
      </Typography>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Box display={"flex"} gap={"20px"}>
          <FormControl fullWidth>
            <FormLabel color="secondary" required label>
              {Translation?.CurrentEmail}
            </FormLabel>
            <TextField
              disabled
              value={profileInfo.Email}
              size="small"
              placeholder={Translation?.EnterCurrentEmail}
            />
          </FormControl>
          <FormControl fullWidth>
            <FormLabel color="secondary" required label>
              {Translation?.UpdateEmail}
            </FormLabel>
            <TextField
              error={touched.UpdateEmail && errors.UpdateEmail}
              helperText={touched.UpdateEmail && errors.UpdateEmail && errors.UpdateEmail}
              onChange={handleChange}
              onBlur={handleBlur}
              type="email"
              size="small"
              name="UpdateEmail"
              value={values.UpdateEmail}
              disabled={tab === 2}
              placeholder={Translation?.EnterUpdateEmail}
            />
          </FormControl>
        </Box>

        { tab === 2 &&
          <FormControl fullWidth>
            <FormLabel color="secondary" required label>
              {Translation?.EnterOTP}
            </FormLabel>
            <OTPInput separator={<span>-</span>} value={otp} onChange={setOtp} length={6} />
          </FormControl>
        }

        { tab === 2 ?
          <Button
            type="button"
            variant="outlined"
            sx={{ width: "fit-content", marginTop: "15px" }}
            onClick={handleVerifyOtp}
          >
            {Translation?.UpdateEmailDetails}
          </Button> : 
          <Button
            type="submit"
            variant="outlined"
            sx={{ width: "fit-content", marginTop: "15px" }}
            disabled={!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.UpdateEmail))}
          >
            {Translation?.SendOTP}
          </Button>
        }
      </form>
      <Typography variant="subtitle" fontWeight={500}>
        {Translation?.SocialLoginProvider}
      </Typography>
      <Box display={"flex"} flexDirection={"column"} gap="15px">
        {socialMedias.map((item, i) => {
          return (
            <Box className="socialBox" key={i}>
              <item.icon />{" "}
              <Typography variant="subtitle" fontWeight={500}>
                {Translation[item.label]}
              </Typography>
              {/* { item.label !== 'LinkedIn' &&
                <Button variant="outlined" onClick={() => handleLinkedAccount(item.label)}>
                  {Translation?.Add}
                </Button>
              } */}

              { item.label !== 'LinkedIn' ? 
                socialMediaProvider.includes(item.providerId) ?
                <Link fontWeight={500} underline="none" color="error" onClick={() => handleRemoveAccount(item.label, item.providerId)} sx={{ cursor: 'pointer' }}>
                  {Translation?.Remove}
                </Link> : 
                <Link fontWeight={500} underline="none" color="primary" onClick={() => handleLinkedAccount(item.label, item.providerId)} sx={{ cursor: 'pointer' }}>
                  {Translation?.Add}
                </Link> : <></>
              }
            </Box>
          )
        })}
        {/* <Box className="socialBox">
          <Avatar
            sx={(theme) => ({
              bgcolor: theme.palette.primary.main,
              width: 32,
              height: 32,
            })}
          >
            R
          </Avatar>
          <Typography variant="subtitle" fontWeight={500}>
            rashidfarook@gmail.com
          </Typography>
          <Link fontWeight={500} underline="none" href="#" color="error">
            Remove
          </Link>
        </Box>
        <Box className="socialBox">
          <Avatar
            sx={(theme) => ({
              bgcolor: theme.palette.primary.main,
              width: 32,
              height: 32,
            })}
          >
            R
          </Avatar>
          <Typography variant="subtitle" fontWeight={500}>
            rashidfarook@hotmail.com
          </Typography>
          <Link fontWeight={500} underline="none" href="#" color="error">
            Remove
          </Link>
        </Box> */}
      </Box>
    </Grid2>
  );
};

export default ChangeEmailSection;
